/* eslint-disable max-len */
import { convertToCurrentGMT, formatDate, getDateRemainFromNow, addAvatarText } from '_utils/function'
import React, { useState } from 'react'
import { formatUnixToDate } from '_utils/formatNumber'
import ImageSlider from '_components/ImageSlider'
import { useHistory } from 'react-router-dom'
import { FiLink, FiShare2 } from 'react-icons/fi'
import { useModal } from '_hooks/useModal'
import useShareLinkEvent from '_hooks/useShareLinkEvent'
import { NOT_PAYNOW, PAYABLE } from '_utils/constant'
import { setCreateEventData } from '_utils/localData'
import useUserRole from '_hooks/useUserRole'
import ModalExternalLink from '../../components/ModalExternalLink'

const EventSummaryCard = ({
  eventDetail,
  groupDetail,
  // listImages,
  collectionTimeStart,
  collectionTimeEnd
}) => {
  const { userInfo, isAdmin, isHostOrAdmin } = useUserRole(groupDetail)
  const history = useHistory()
  const isCreator = Boolean(
    userInfo?.id && eventDetail?.createdUserId && String(userInfo.id) === String(eventDetail.createdUserId)
  )
  const canRehost = isCreator || isAdmin
  const [isCopied, setIsCopied] = useState(false)
  const { handleShare, isLoading: isLoadingShare } = useShareLinkEvent()
  const totalBuy = eventDetail?.products?.reduce((pre, cur) => pre + (cur.orderCount || 0), 0) || 0

  const listLinkModal = useModal()

  const onClickShare = () => {
    if (isLoadingShare || isCopied) return
    handleShare(eventDetail?.id, (url) => {
      navigator.clipboard.writeText(url)
      setIsCopied(true)
      setTimeout(() => {
        setIsCopied(false)
      }, 2000)
    })
  }

  return (
    <div className="edv2-card">
      <div className="edv2-card__head-v2">
        <div className="edv2-card__head-main">
          <div className="edv2-card__head-left-v2">
            {eventDetail?.createdUserPhotoUrl ? (
              <img
                className="edv2-avatar"
                src={eventDetail?.createdUserPhotoUrl}
                alt={eventDetail?.title || ''}
              />
            ) : (
              <div className="edv2-avatar">{addAvatarText(groupDetail?.group?.name || eventDetail?.createdUserName || 'EV')}</div>
            )}
            <div className="edv2-card__head-info">
              <h3>{eventDetail?.groupName}</h3>
              <p>Created by {eventDetail?.createdUserName}</p>
            </div>
          </div>
          <div className="edv2-card__head-meta-v2">
            <div className="edv2-days-left-v2">
              {getDateRemainFromNow(convertToCurrentGMT(eventDetail.closingTime))} left
            </div>
            <div className="edv2-buy-pill-v2">{totalBuy} BUY</div>
          </div>
        </div>
        {canRehost && (
          <div className="edv2-card__actions">
            {isCreator && (
            <button
              type="button"
              className="gd-admin-link"
              onClick={(e) => {
                e.stopPropagation()
                if (eventDetail?.paynow === NOT_PAYNOW && eventDetail?.payable === PAYABLE) {
                  alert('Not allow to edit event')
                } else {
                  let clonedEvent = { ...eventDetail }
                  delete clonedEvent.orders
                  if (clonedEvent.products) {
                    for (let i = 0; i < clonedEvent.products.length; i++) {
                      clonedEvent.products[i].pid = clonedEvent.products[i].id
                    }
                  }
                  const { closingTime, pickupTime } = clonedEvent
                  const closingTimeCurrentGMT = convertToCurrentGMT(closingTime)
                  const pickupTimeCurrentGMT = convertToCurrentGMT(pickupTime)
                  clonedEvent = {
                    ...clonedEvent,
                    closingTime: closingTimeCurrentGMT,
                    pickupTime: pickupTimeCurrentGMT,
                  }
                  setCreateEventData(clonedEvent)
                  history.push(`/event/hosting?id=${eventDetail?.id}`)
                }
              }}
            >
              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
              </svg>
              Edit Event
            </button>
            )}
            {isCreator && (
            <button
              type="button"
              className="gd-admin-link"
              onClick={(e) => {
                e.stopPropagation()
                history.push(`/event/manage-orders?eventId=${eventDetail?.id}`)
              }}
            >
              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M9 11l3 3L22 4" />
                <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
              </svg>
              View Orders
            </button>
            )}
            <button
              type="button"
              className="gd-admin-link"
              onClick={(e) => {
                e.stopPropagation()
                history.push(`/event/hosting?id=${eventDetail?.id}&fromReHost=1`)
              }}
            >
              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M4 4h16v16H4z" />
                <path d="M4 9h16" />
                <path d="M9 4v16" />
              </svg>
              Rehost
            </button>
          </div>
        )}
      </div>

      <ImageSlider
        images={eventDetail?.photoUrls}
        alt={eventDetail?.title}
      />

      <div className="edv2-card__body">
        <h4>{eventDetail?.title}</h4>
        <p className="edv2-description">{eventDetail?.description}</p>

        <div className="edv2-info-row">
          <span className="edv2-info-label">Event open:</span>
          <span className="edv2-info-value">
            {formatUnixToDate(eventDetail?.createdAt)}
          </span>
        </div>
        <div className="edv2-info-row">
          <span className="edv2-info-label">Event close:</span>
          <span className="edv2-info-value">
            {formatDate({ date: convertToCurrentGMT(eventDetail.closingTime) })}
          </span>
        </div>
        <div className="edv2-info-row">
          <span className="edv2-info-label">Collection:</span>
          <span className="edv2-info-value">
            {formatDate({ date: convertToCurrentGMT(eventDetail.pickupTime) })}
            {collectionTimeStart && collectionTimeEnd ? ` (${collectionTimeStart} - ${collectionTimeEnd})` : ''}
          </span>
        </div>
        {eventDetail?.pickupAddress &&
          <div className="edv2-info-row">
            <span className="edv2-info-label">Address:</span>
            <span className="edv2-info-value">{eventDetail?.pickupAddress}</span>
          </div>
        }
      </div>
      {(eventDetail?.extraFields?.list?.length > 0 || isCreator) && (
        <div className="edv2-card__footer">
          <div className="edv2-footer-left">
            {eventDetail?.extraFields?.list?.length === 1 && eventDetail?.extraFields?.list[0] && (
              <div className="edv2-footer-link-wrapper">
                <FiLink className="edv2-footer-link-icon" />
                <a
                  href={eventDetail?.extraFields?.list[0]?.value || '#'}
                  target="_blank"
                  rel="noreferrer"
                  className="edv2-footer-link"
                >
                  {eventDetail?.extraFields?.list[0]?.name || ''}
                </a>
              </div>
            )}
            {eventDetail?.extraFields?.list?.length > 1 && (
              <div className="edv2-footer-link-wrapper" onClick={listLinkModal.toggleModal}>
                <FiLink className="edv2-footer-link-icon" />
                <span className="edv2-footer-link">
                  {eventDetail?.extraFields?.list?.length} Links
                </span>
              </div>
            )}
          </div>
          {isHostOrAdmin && (
            <button
              type="button"
              className="edv2-footer-share-btn"
              aria-label="Share"
              onClick={onClickShare}
              disabled={isLoadingShare}
            >
              {isCopied ? <span className="edv2-footer-copied-text">Copied</span> : <FiShare2 />}
            </button>
          )}
        </div>
      )}

      <ModalExternalLink
        isOpen={listLinkModal.isOpen}
        toggle={listLinkModal.toggleModal}
        extraFields={eventDetail?.extraFields}
      />
    </div>
  )
}

export default EventSummaryCard
